import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';

import { ProductChoiceComponent } from './product-choice.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    MatCardModule,
    MatDividerModule,
    
  ],
  exports: [
    ProductChoiceComponent
  ],
  providers: [
  ],
  declarations: [
    ProductChoiceComponent
  ]
})
export class ProductChoiceModule { }
